import api from "../middlware/api";
import { BASE_URL } from "../constants";

export type RefundMode = "cash" | "credit" | "adjust_against_next_bill";

export interface CreateSaleReturnItemPayload {
  sale_item_id: number;
  qty_returned: number;
  restock_flag?: boolean;
}

export interface CreateSaleReturnPayload {
  sale_id: number;
  return_date?: string;
  reason?: string;
  is_gst_adjustable?: boolean;
  credit_note_no?: string | null;
  credit_note_date?: string | null;
  refund_mode: RefundMode;
  items: CreateSaleReturnItemPayload[];
}

export const getSaleReturns = (params?: Record<string, any>) => {
  return new Promise((resolve, reject) => {
    const query = new URLSearchParams();
    if (params) {
      for (const key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          query.set(key, params[key]);
        }
      }
    }
    const queryString = query.toString();
    const url = queryString
      ? `${BASE_URL}/api/v1/sale-returns?${queryString}`
      : `${BASE_URL}/api/v1/sale-returns`;

    api
      .get(url)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getSaleReturnById = (id: number) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/sale-returns/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const createSaleReturn = (payload: CreateSaleReturnPayload) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/sale-returns`, payload)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
